import React from "react";
import ItemRecentLineup from "./item";
import NoData from "@/components/NoData";

const DataRecentLineupComponent = ({ lineupData }) => {
  return (
    <div className="grid grid-cols-1 @md:grid-cols-2 max-w-[816px] mt-5 mb-[24px] m-auto gap-[16px] [&>*]:rounded-[4px]">
      <div className="rounded-lg bg-[var(--theme-foreground)] border border-[var(--theme-border)]">
      <div className="home_name rounded-[4px] rounded-bl-none bg-[var(--theme-primary)] text-sm pl-8 pr-12 pt-[3px] text-[var(--theme-on-primary)] w-max">
          {lineupData.homeTeam.name}
        </div>
        <div className="bg-[var(--theme-accent)] font-bold text-[var(--theme-text)] py-[6px] text-[10px] pl-8 border-b border-[var(--theme-border)]">
          Đội hình ({lineupData.homeTeam.formation})
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[6px] py-[8px] pl-8">
          {lineupData.homeTeam.lineup.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={player.namePosition}
              name={player.name}
            />
          ))}
        </div>
        <div className="bg-[var(--theme-accent)] font-bold text-[var(--theme-text)] py-[6px] text-[10px] pl-8 border-b border-[var(--theme-border)]">
          Dự bị
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[6px] py-[8px] pl-8">
          {lineupData.homeTeam.substitutes.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={null}
              name={player.name}
            />
          ))}
        </div>
      </div>

      <div className="[&>*]:ml-auto rounded-lg bg-[var(--theme-foreground)] border border-[var(--theme-border)]">
      <div className="home_name ml-auto text-right rounded-[4px] rounded-br-none bg-[var(--theme-highlight)] text-sm pl-12 pt-[3px] text-[var(--theme-on-highlight)] w-max pr-8">
          {lineupData.awayTeam.name}
        </div>
        <div className="bg-[var(--theme-accent)] font-bold text-[var(--theme-text)] py-[6px] text-[10px] pl-8 border-b border-[var(--theme-border)]">
          Đội hình ({lineupData.awayTeam.formation})
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[6px] py-[8px] pl-8">
          {lineupData.awayTeam.lineup.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={player.namePosition}
              name={player.name}
              styles={{
                numberClass:
                  "bg-[var(--theme-highlight)] text-[var(--theme-on-highlight)]",
              }}
            />
          ))}
        </div>
        <div className="pl-8 bg-[var(--theme-accent)] font-bold text-[var(--theme-text)] py-[6px] text-[10px] border-b border-[var(--theme-border)]">
          Dự bị
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[6px] py-[8px] pl-8">
          {lineupData.awayTeam.substitutes.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={null}
              name={player.name}
              styles={{
                numberClass:
                  "bg-[var(--theme-highlight)] text-[var(--theme-on-highlight)]",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const DataRecentLineup = ({ lineupData, match }) => {
  const homeformation = lineupData?.data?.homeLineUpLastMatch?.lineUps?.[0]?.homeFormation || "";
  const awayformation = lineupData?.data?.awayLineUpLastMatch?.lineUps?.[0]?.awayFormation || "";
  
  const homeLineupData = lineupData?.data?.homeLineUpLastMatch?.lineUps?.[0]?.playerLineUps || [];
  const awayLineupData = lineupData?.data?.awayLineUpLastMatch?.lineUps?.[0]?.playerLineUps || [];
  
  const homeMainPlayers = homeLineupData?.filter((player) => player.type === "home") || [];
  const homeBackupPlayers = homeLineupData?.filter((player) => player.type === "homeBackup") || [];
  
  const awayMainPlayers = awayLineupData?.filter((player) => player.type === "away") || [];
  const awayBackupPlayers = awayLineupData?.filter((player) => player.type === "awayBackup") || [];
  
  const lineupDatax = {
    homeTeam: {
      name: match?.homeTeam?.name || "",
      formation: homeformation,
      lineup: homeMainPlayers,
      substitutes: homeBackupPlayers,
    },
    awayTeam: {
      name: match?.awayTeam?.name || "",
      formation: awayformation,
      lineup: awayMainPlayers,
      substitutes: awayBackupPlayers,
    },
  };
  if(homeLineupData.length == 0 && awayLineupData.length == 0){
    return (
      match.status === "-1" ? 
        <NoData message="Không có dữ liệu"/>
        :
        <NoData message="Đang cập nhật..."/>
    )
  }
  return <DataRecentLineupComponent lineupData={lineupDatax} />;
};

export default React.memo(DataRecentLineup);
